export default __webpack_public_path__ + "static/media/Group846545011.25111d0f.svg";